import React from 'react';
import { Button } from './button';
import { FileText, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface GenerateReportButtonProps {
  moduleName: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  title?: string;
}

export const GenerateReportButton: React.FC<GenerateReportButtonProps> = ({
  moduleName,
  onClick,
  isLoading = false,
  disabled = false,
  className,
  title
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled || isLoading}
     // size="sm"
      className={cn(
        "bg-[#EB1C37] hover:bg-[#EB1C37]/90 text-white flex items-center gap-2",
        className
      )}
      title={title}
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <FileText className="h-4 w-4" />
      )}
      {isLoading ? 'Generating...' : `Generate ${moduleName}`}
    </Button>
  );
};

